import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SharedButton from '../../components/Shared/SharedButton';
import CostCenterTable from './CostCenterTable';
import { useNavigate } from 'react-router-dom';
import useFetchData from '../../hooks/useFetchData';

export default function CostCenterMain() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: costCenterData, loading, executeFetch } = useFetchData();

  const handleRefresh = () => {
    executeFetch("POST", "listCostcenter");
  };

  useEffect(() => {
    executeFetch("POST", "listCostcenter");
  }, [executeFetch]);

  return (
    <>
      <div className='flex justify-end mb-2'>
        <SharedButton
          label={t('CreateCostCenter')}
          icon='pi pi-plus'
          onClick={() => navigate('/manager/costCenter/create')}
          className='bg-primary primary-btn'
        />
      </div>
      <CostCenterTable
        data={costCenterData?.data}
        loading={loading}
        onRefresh={handleRefresh}
      />
    </>
  );
}
